<template>
  <div
    class="flex items-end gap-[12px] [&_label]:!text-[14px] [&_label]:!text-[#333333] [&_input]:w-[100px]"
    :class="{
      '[&_input]:!border-[#F95031]': isEditable,
    }"
  >
    <div>
      <label for="lebar">Lebar</label>
      <b-input
        id="lebar"
        ref="lebarInput"
        v-model="localValue.product_width"
        :disabled="!isEditable || disabled"
        :formatter="e => formatInput(e, 'product_width')"
        @input.native="setCursorAfterNumber"
      />
    </div>
    <div>
      <label for="panjang">Panjang</label>
      <b-input
        id="panjang"
        v-model="localValue.product_length"
        :disabled="!isEditable || disabled"
        :formatter="e => formatInput(e, 'product_length')"
        @input.native="setCursorAfterNumber"
      />
    </div>
    <div>
      <label for="tinggi">Tinggi</label>
      <b-input
        id="tinggi"
        v-model="localValue.product_height"
        :disabled="!isEditable || disabled"
        :formatter="e => formatInput(e, 'product_height')"
        @input.native="setCursorAfterNumber"
      />
    </div>
    <div>
      <b-button
        variant="primary"
        size="sm"
        class="!size-[34.55px] !p-0 !flex items-center justify-center"
        :disabled="isEditable || disabled"
        @click="enableEdit"
      >
        <span class="k-edit text-[16px]" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEditable: false,
      localValue: {
        product_width: '0 cm',
        product_length: '0 cm',
        product_height: '0 cm',
      },
    }
  },
  created() {
    this.localValue = {
      product_width: `${this.product.product_width} cm`,
      product_length: `${this.product.product_length} cm`,
      product_height: `${this.product.product_height} cm`,
    }
  },
  methods: {
    enableEdit() {
      this.isEditable = true
    },
    formatInput(value, name) {
      const numericValue = value.replace(/[^\d]/g, '')
      const parsedNumber = Number(numericValue)
      this.$emit('input-dimension', { name, value: parsedNumber })
      const cleanedValue = numericValue ? String(parsedNumber) : '0'
      return `${cleanedValue} cm`
    },
    setCursorAfterNumber(event) {
      const { target } = event
      const { value } = target

      if (event && value.length > 3) {
        this.$nextTick(() => {
          target.setSelectionRange(value.length - 3, value.length - 3)
        })
      }
    },
  },
}
</script>
